import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  Grid,
  Stepper,
  Typography,
  DialogContent,
  Stack,
  CardContent,
  IconButton,
  Collapse,
  Divider,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { useStyles } from "../../../theme/appStyles";
import {
  useGetDriverQuery,
  useGetAllDriverHistoryQuery,
  useGetUserInfoOnyQuery,
} from "../../../Api/attoDeskApi";
import {
  IUserAdmin,
  IDriverLicense,
  IDriverLicenseHistory,
} from "../../../Api/Interface/api.interface";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import AvatarImg from "../../../Images/avatar.png";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import useUser from "../../../Core/hook/useUser";
import "jspdf-autotable";
import useIsMobile from "../../../Core/hook/useIsMobile";
import "react-quill/dist/quill.snow.css";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import dayjs, { Dayjs } from "dayjs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { FaEdit, FaTrash, FaExchangeAlt } from "react-icons/fa";
import { GrStatusGood } from "react-icons/gr";
import { IoPricetagsOutline } from "react-icons/io5";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { styled } from "@mui/material/styles";
import NewPopUpteam from "../Edit/index";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

enum Section {
  Info = "Info",
  Email = "Email",
  Email2 = "Email2",
  TimeSlot = "TimeSlot",
  Payroll = "Payroll",
  Attendance = "Attendance",
}

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const statusIcon = {
  Created: <BiSolidMessageSquareAdd color="green" size={17} />,
  Modified: <FaEdit color="orange" />,
  Deleted: <FaTrash color="red" />,
  ChangedBranch: <FaExchangeAlt color="orange" />,
  ChangedStatusGreen: <GrStatusGood color="green" />,
  ChangedStatusOrange: <GrStatusGood color="orange" />,
  storeChanged: <BiSolidMessageSquareAdd size={17} color="green" />,
  priceChanged: <IoPricetagsOutline size={17} color="red" />,
};

const isEmpty = (value: any) =>
  value === null || value === undefined || value === "" || value === "-";

const getStatusType = (oldValue: any, newValue: any) => {
  // console.log("🔍 Checking status:", {
  //   oldValue,
  //   newValue,
  //   oldEmpty: isEmpty(oldValue),
  //   newEmpty: isEmpty(newValue),
  // });

  const oldEmpty = isEmpty(oldValue);
  const newEmpty = isEmpty(newValue);

  if (oldEmpty && !newEmpty) {
    return "Created"; // only new value exists
  } else if (!oldEmpty && !newEmpty) {
    return "Modified"; // both values exist
  } else if (!oldEmpty && newEmpty) {
    return "Deleted"; // only old value exists
  }
  return null; // both empty (no change)
};

const variantPropName = (unit: string) => {
  switch (unit) {
    case "license_number":
      return "License Number";
    case "first_name":
      return "First Name";
    case "last_name":
      return "Last Name";
    case "address":
      return "Address";
    case "sex":
      return "Sex";
    case "date_of_birth":
      return "Date of irth";
    case "issue_date":
      return "Issue Date";
    case "expiry_date":
      return "Expiry Date";
    case "license_img":
      return "Image";
    default:
      return "";
  }
};

const ExpandMore = styled((props: any) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }: any) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Index = () => {
  const classes = useStyles();
  const [activeSection, setActiveSection] = useState<Section>(Section.Info);
  const handleContainerChange = (section: Section) => {
    setActiveSection(section);
  };
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();
  const { id: customerId } = useParams<{ id: string }>();
  const { userHasRight } = useUser();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectCustomer, setSelectCustomer] = useState<IDriverLicense | null>(
    null
  );
  const [expandedTemplateIdHis, setExpandedTemplateIdHis] = useState<
    number | null
  >(null);
  const [expandedTemplateId, setExpandedTemplateId] = useState<string | null>(
    null
  );
  useEffect(() => {}, [customerId]);

  const { data, isLoading, isError } = useGetDriverQuery({
    searchText: "",
    id: String(customerId),
  });

  const {
    data: customerProjectHistoryData,
    isLoading: customerProjectDataHistoryIsLoading,
    refetch: cutomerProjectHistoryRefetch,
    isError: cutomerProjectHistoryIsError,
  } = useGetAllDriverHistoryQuery({
    searchText: "",
    id: String(customerId),
  });

  const { data: userListData, isLoading: userIsLoading } =
    useGetUserInfoOnyQuery({
      searchText: "",
    });

  const [openImage, setOpenImage] = useState(false);
  const [selectedEmpImg, setSelectedEmpImg] = useState<string>("");

  const [selectedCoursing, setSelectedCoursing] = useState<IUserAdmin | null>(
    null
  );
  const [openDialogEditUser, setOpenDialogEditUser] = useState(false);

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IDriverLicense;
    }
    return null;
  }, [data]);

  const userList = useMemo(() => {
    return userListData?.data as IUserAdmin[];
  }, [userListData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const handleOpenEditSuites = () => {
    setSelectCustomer(customer);
    setOpenDialog(true);
  };

  const handleOpenImage = (imgUrl: string) => {
    setSelectedEmpImg(imgUrl);
    setOpenImage(true);
  };

  const handleCloseDialog = () => {
    setSelectCustomer(null);
    setOpenDialogEditUser(false);
  };

  const handleCloseImage = () => {
    setSelectedEmpImg("");
    setOpenImage(false);
  };

  const getChangedFields = (
    current: IDriverLicenseHistory,
    prev: IDriverLicenseHistory | null,
    maps: {}
  ) => {
    if (!prev) return [];

    const formatTime = (time: string) =>
      dayjs(`1970-01-01T${time}`).format("hh:mm A");

    const formatFieldValue = (
      field: keyof IDriverLicenseHistory,
      value: any
    ): string => {
      if (value === undefined || value === null) return "-";

      switch (field) {
        case "issue_date":
          return dayjs(value).format("MMM D, YYYY");
        case "expiry_date":
          return dayjs(value).format("MMM D, YYYY");
        case "date_of_birth":
          return dayjs(value).format("MMM D, YYYY");
        case "license_number":
          return `${value}`;
        case "first_name":
          return `${value}`;
        case "last_name":
          return `${value}`;
        case "sex":
          return `${value}`;
        case "address":
          return `${value}`;
        case "license_img":
          return `${value}`;
        default:
          return String(value);
      }
    };

    const fieldsToCheck: (keyof IDriverLicenseHistory)[] = [
      "license_number",
      "first_name",
      "last_name",
      "address",
      "sex",
      "date_of_birth",
      "issue_date",
      "expiry_date",
      "license_img",
    ];

    return fieldsToCheck
      .map((field) => {
        if (current[field] !== prev[field]) {
          return {
            field,
            oldValue: formatFieldValue(field, prev[field]),
            newValue: formatFieldValue(field, current[field]),
          };
        }
        return null;
      })
      .filter(Boolean) as {
      field: keyof IDriverLicenseHistory;
      oldValue: string;
      newValue: string;
    }[];
  };

  const getCreatedFields = (current: IDriverLicenseHistory, maps: {}) => {
    const formatTime = (time: string) =>
      dayjs(`1970-01-01T${time}`).format("hh:mm A");

    const formatFieldValue = (
      field: keyof IDriverLicenseHistory,
      value: any
    ): string => {
      if (value === undefined || value === null || value === "") return "";

      switch (field) {
        case "issue_date":
          return dayjs(value).format("MMM D, YYYY");
        case "expiry_date":
          return dayjs(value).format("MMM D, YYYY");
        case "date_of_birth":
          return dayjs(value).format("MMM D, YYYY");
        case "license_number":
          return `${value}`;
        case "first_name":
          return `${value}`;
        case "last_name":
          return `${value}`;
        case "sex":
          return `${value}`;
        case "address":
          return `${value}`;
        case "license_img":
          return `${value}`;
        default:
          return String(value);
      }
    };

    const fieldsToCheck: (keyof IDriverLicenseHistory)[] = [
      "license_number",
      "first_name",
      "last_name",
      "address",
      "sex",
      "date_of_birth",
      "issue_date",
      "expiry_date",
      "license_img",
    ];

    return fieldsToCheck
      .map((field) => {
        const formatted = formatFieldValue(field, current[field]);
        if (formatted) {
          return { field, value: formatted };
        }
        return null;
      })
      .filter(Boolean) as {
      field: keyof IDriverLicenseHistory;
      value: string;
    }[];
  };

  const toggleExpand = (id: string) => {
    setExpandedTemplateId((prev) => (prev === id ? null : id));
  };

  const toggleExpandHis = (id: number) => {
    setExpandedTemplateIdHis((prev) => (prev === id ? null : id));
  };

  const historyRecords: IDriverLicense[] = Array.isArray(
    customerProjectHistoryData?.data
  )
    ? (customerProjectHistoryData?.data as IDriverLicense[])
    : [];

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching Staff data. Please try again later.
      </Typography>
    );
  }

  if (!customer) {
    return <Typography>No Staff data available.</Typography>;
  }

  const handleAddProductClick = () => {
    navigate(`/team/schedule/pdf/${customerId}`);
  };

  const renderContent = () => {
    switch (activeSection) {
      case Section.Info:
        return (
          <div>
            <Grid container spacing={3}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card
                  className={classes.card}
                  sx={{ minHeight: isMobileRes ? 200 : 200 }}
                >
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 3, padding: 2 }}
                    className={classes.activityHistoryHeaderGrid}
                  >
                    <Grid
                      item
                      pt={2}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography className={classes.cardTitle}>
                        Profile
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid container spacing={1} justifyContent="flex-end">
                        <Grid item>
                          <Button
                            startIcon={<EditSharpIcon />}
                            className={classes.ordeListEditButton}
                            onClick={handleOpenEditSuites}
                          >
                            Edit
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={2} sx={{ padding: 2 }}>
                        {(customer.first_name ||
                          customer.last_name ||
                          customer.address ||
                          customer.sex ||
                          customer.date_of_birth) && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {(customer.first_name ||
                                      customer.last_name) && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Full Name
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {`${capitalizeFirstLetter(
                                              customer.first_name || ""
                                            )} ${capitalizeFirstLetter(
                                              customer.last_name || ""
                                            )}`}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {customer.address && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Address
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {customer.address}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {customer.sex && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            E-mail
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {customer.sex}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {customer.date_of_birth && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Date of Birth
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {customer.date_of_birth
                                              ? dayjs(
                                                  customer.date_of_birth
                                                ).format("YYYY-MM-DD")
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {customer.issue_date && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Issue Date
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {customer.issue_date
                                              ? dayjs(
                                                  customer.issue_date
                                                ).format("YYYY-MM-DD")
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}{" "}
                                    {customer.expiry_date && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Expiry Date
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {customer.expiry_date
                                              ? dayjs(
                                                  customer.expiry_date
                                                ).format("YYYY-MM-DD")
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={8} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid container>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.profileBottomSetUp}
                  >
                    <Grid className={classes.profileBottomDwon}>
                      {customer ? (
                        customer.license_img ? (
                          <img
                            src={customer.license_img}
                            alt="Profile"
                            className={classes.profileImage}
                            onClick={() =>
                              handleOpenImage(customer.license_img)
                            }
                            style={{ cursor: "pointer" }}
                          />
                        ) : (
                          <Avatar
                            alt="Travis Howard"
                            src={AvatarImg}
                            className={classes.profileImage}
                          />
                        )
                      ) : (
                        <Avatar
                          alt="Travis Howard"
                          src={AvatarImg}
                          className={classes.profileImage}
                        />
                      )}
                    </Grid>

                    <Grid className={classes.buttonGroupList}>
                      <Typography
                        variant="h4"
                        className={classes.profileDetailItemList}
                      >
                        {capitalizeFirstLetter(customer.first_name || "") +
                          " " +
                          capitalizeFirstLetter(customer.last_name || "")}
                      </Typography>
                    </Grid>

                    <Grid>
                      <Grid className={classes.buttonGroup}>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Info)}
                          >
                            <InfoOutlinedIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Info
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Email)}
                          >
                            <EmailOutlined />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Email
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() =>
                              handleContainerChange(Section.TimeSlot)
                            }
                          >
                            <AccessTimeRoundedIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Schedule
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              {renderContent()}
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={4} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.activityHistoryHeaderGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography
                          className={classes.ActivityHistoryHEading}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <UpdateOutlinedIcon style={{ marginRight: "8px" }} />
                          History
                        </Typography>
                      </Grid>
                    </Grid>

                    {historyRecords.length > 0 && (
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Card className={classes.card}>
                          <Grid item lg={12} md={12} sm={12} xs={12} p={2}>
                            <Box
                              sx={{
                                // minHeight: "60vh",
                                maxHeight: "100vh",
                                overflow: "auto",
                                padding: "2px",
                                "&::-webkit-scrollbar": {
                                  width: "4px",
                                },
                                "&::-webkit-scrollbar-track": {
                                  background: "#eeeeee",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  background: "#eeeeee",
                                  borderRadius: "10px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                  background: "#eeeeee",
                                },
                              }}
                            >
                              <Stack spacing={2}>
                                {historyRecords.map((order, index) => {
                                  const statusName = order.updated_by
                                    ? "Updated"
                                    : "Created";

                                  const statusNameIcon = order.updated_by
                                    ? "ChangedStatusOrange"
                                    : "ChangedStatusGreen";

                                  const userName =
                                    userMap.get(order.created_by) || "";
                                  return (
                                    <Card
                                      key={order.id}
                                      variant="outlined"
                                      className={classes.orderListRightCard2}
                                    >
                                      <CardContent>
                                        <Stack
                                          spacing={1}
                                          mb={1}
                                          // onClick={() =>
                                          //   toggleExpandHis(order.id)
                                          // }
                                          sx={{ cursor: "pointer" }}
                                        >
                                          <Stack
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="space-between"
                                            sx={{ mb: 1 }}
                                          >
                                            <Typography
                                              variant="h6"
                                              fontWeight={600}
                                            >
                                              {dayjs(order.created_at).format(
                                                "MMM D, YYYY h:mm A"
                                              )}
                                            </Typography>

                                            {/* <ExpandMore
                                              expand={
                                                expandedTemplateIdHis ===
                                                order.id
                                              }
                                              onClick={() =>
                                                toggleExpandHis(order.id)
                                              }
                                              aria-expanded={
                                                expandedTemplateIdHis ===
                                                order.id
                                              }
                                            >
                                              <ExpandMoreIcon />
                                            </ExpandMore> */}
                                          </Stack>

                                          <Stack
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                            spacing={1}
                                            flexWrap="wrap"
                                          >
                                            <Typography
                                              variant="body2"
                                              className={
                                                classes.orderLsitHeadingTypoColor
                                              }
                                            >
                                              {order.license_number}
                                            </Typography>

                                            <Typography
                                              variant="body2"
                                              className={
                                                classes.orderLsitHeadingTypoColor
                                              }
                                            >
                                              {` | ${userName}`}
                                            </Typography>
                                          </Stack>
                                          <>
                                            <Stack spacing={1} mb={1}>
                                              <Stack
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                                spacing={1}
                                                flexWrap="wrap"
                                              >
                                                {
                                                  statusIcon[
                                                    statusNameIcon as keyof typeof statusIcon
                                                  ]
                                                }

                                                <Typography
                                                  fontWeight={600}
                                                  sx={{
                                                    color:
                                                      statusName === "Created"
                                                        ? "green"
                                                        : "orange",
                                                  }}
                                                >
                                                  <strong>{statusName}</strong>
                                                </Typography>
                                              </Stack>
                                            </Stack>
                                          </>
                                        </Stack>
                                        <Stack spacing={1} mb={1}>
                                          {order.driver_history.length > 0 ? (
                                            <Grid
                                            // in={
                                            //   expandedTemplateIdHis ===
                                            //   order.id
                                            // }
                                            // timeout="auto"
                                            // unmountOnExit
                                            >
                                              <Divider sx={{ mb: 2 }} />
                                              {(() => {
                                                const msg =
                                                  order.driver_history[0];
                                                const createdFields =
                                                  getCreatedFields(msg, {});

                                                return (
                                                  <Box key={msg.id} pb={4}>
                                                    <Stack
                                                      direction="row"
                                                      alignItems="center"
                                                      justifyContent="space-between"
                                                      sx={{ mb: 1 }}
                                                    >
                                                      <Typography
                                                        color="primary"
                                                        style={{
                                                          fontWeight: 600,
                                                        }}
                                                      >
                                                        <Box
                                                          display="flex"
                                                          alignItems="center"
                                                          gap={1}
                                                        >
                                                          <PublishedWithChangesIcon
                                                            fontSize="medium"
                                                            color="primary"
                                                            style={{
                                                              fontSize: 20,
                                                              fontWeight: 600,
                                                            }}
                                                          />
                                                          {userMap.get(
                                                            msg.created_by
                                                          ) || ""}{" "}
                                                          created record:
                                                        </Box>
                                                      </Typography>

                                                      <Typography variant="h6">
                                                        {dayjs(
                                                          msg.created_at
                                                        ).format(
                                                          "MMM D, YYYY h:mm A"
                                                        )}
                                                      </Typography>
                                                    </Stack>

                                                    {createdFields.map(
                                                      (item, idx) => (
                                                        <Box
                                                          key={idx}
                                                          mb={2}
                                                          ml={4}
                                                        >
                                                          <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            spacing={1}
                                                          >
                                                            {
                                                              statusIcon[
                                                                "Created"
                                                              ]
                                                            }
                                                            <Typography
                                                              variant="body2"
                                                              display="flex"
                                                              alignItems="center"
                                                              gap={1}
                                                            >
                                                              {variantPropName(
                                                                item.field
                                                              )}{" "}
                                                              added ➜{" "}
                                                              {item.field ===
                                                              "license_img" ? (
                                                                <img
                                                                  src={
                                                                    item.value
                                                                  }
                                                                  alt="New"
                                                                  style={{
                                                                    width: 80,
                                                                    height: 50,
                                                                    objectFit:
                                                                      "cover",
                                                                    borderRadius: 4,
                                                                  }}
                                                                />
                                                              ) : (
                                                                item.value
                                                              )}
                                                            </Typography>

                                                            {/* <Typography variant="body2">
                                                              {variantPropName(
                                                                item.field
                                                              )}{" "}
                                                              added ➜{" "}
                                                              {item.value}
                                                            </Typography> */}
                                                          </Stack>
                                                        </Box>
                                                      )
                                                    )}
                                                  </Box>
                                                );
                                              })()}

                                              {/* Render rest of the history (index > 0) as changes */}
                                              {order.driver_history
                                                .slice(1)
                                                .map((msg, index) => {
                                                  const prev =
                                                    order.driver_history[index]; // prev is previous record
                                                  const changes =
                                                    msg.status === "Updated"
                                                      ? getChangedFields(
                                                          msg,
                                                          prev,
                                                          {}
                                                        )
                                                      : getChangedFields(
                                                          msg,
                                                          prev,
                                                          {}
                                                        );

                                                  return (
                                                    <Box key={msg.id} pb={4}>
                                                      {changes &&
                                                        changes.length > 0 && (
                                                          <>
                                                            <Stack
                                                              direction="row"
                                                              alignItems="center"
                                                              justifyContent="space-between"
                                                              sx={{ mb: 1 }}
                                                            >
                                                              <Typography
                                                                color="primary"
                                                                style={{
                                                                  fontWeight: 600,
                                                                }}
                                                              >
                                                                <Box
                                                                  display="flex"
                                                                  alignItems="center"
                                                                  gap={1}
                                                                >
                                                                  <PublishedWithChangesIcon
                                                                    fontSize="medium"
                                                                    color="primary"
                                                                    style={{
                                                                      fontSize: 20,
                                                                      fontWeight: 600,
                                                                    }}
                                                                  />
                                                                  {userMap.get(
                                                                    msg.created_by
                                                                  ) || ""}{" "}
                                                                  made changes:
                                                                </Box>
                                                              </Typography>

                                                              <Typography variant="h6">
                                                                {dayjs(
                                                                  msg.created_at
                                                                ).format(
                                                                  "MMM D, YYYY h:mm A"
                                                                )}
                                                              </Typography>
                                                            </Stack>

                                                            {changes.map(
                                                              (change, idx) => {
                                                                const statusType =
                                                                  getStatusType(
                                                                    change.oldValue,
                                                                    change.newValue
                                                                  );

                                                                return (
                                                                  <Box
                                                                    key={idx}
                                                                    mb={2}
                                                                    ml={4}
                                                                  >
                                                                    <Stack
                                                                      direction="row"
                                                                      alignItems="center"
                                                                      spacing={
                                                                        1
                                                                      }
                                                                    >
                                                                      {statusType &&
                                                                        statusIcon[
                                                                          statusType
                                                                        ]}
                                                                      <Typography
                                                                        variant="body2"
                                                                        display="flex"
                                                                        alignItems="center"
                                                                        gap={1}
                                                                      >
                                                                        {variantPropName(
                                                                          change.field
                                                                        )}{" "}
                                                                        {statusType ===
                                                                          "Created" && (
                                                                          <>
                                                                            added
                                                                            ➜{" "}
                                                                            {change.field ===
                                                                            "license_img" ? (
                                                                              <img
                                                                                src={
                                                                                  change.newValue
                                                                                }
                                                                                alt="New"
                                                                                style={{
                                                                                  width: 50,
                                                                                  height: 50,
                                                                                  objectFit:
                                                                                    "cover",
                                                                                  borderRadius: 4,
                                                                                }}
                                                                              />
                                                                            ) : (
                                                                              change.newValue
                                                                            )}
                                                                          </>
                                                                        )}
                                                                        {statusType ===
                                                                          "Modified" && (
                                                                          <>
                                                                            changed
                                                                            from{" "}
                                                                            {change.field ===
                                                                            "license_img" ? (
                                                                              <img
                                                                                src={
                                                                                  change.oldValue
                                                                                }
                                                                                alt="Old"
                                                                                style={{
                                                                                  width: 80,
                                                                                  height: 50,
                                                                                  objectFit:
                                                                                    "cover",
                                                                                  borderRadius: 4,
                                                                                  marginRight: 8,
                                                                                }}
                                                                              />
                                                                            ) : (
                                                                              <s>
                                                                                {
                                                                                  change.oldValue
                                                                                }
                                                                              </s>
                                                                            )}{" "}
                                                                            ➜{" "}
                                                                            {change.field ===
                                                                            "license_img" ? (
                                                                              <img
                                                                                src={
                                                                                  change.newValue
                                                                                }
                                                                                alt="New"
                                                                                style={{
                                                                                  width: 80,
                                                                                  height: 50,
                                                                                  objectFit:
                                                                                    "cover",
                                                                                  borderRadius: 4,
                                                                                }}
                                                                              />
                                                                            ) : (
                                                                              change.newValue
                                                                            )}
                                                                          </>
                                                                        )}
                                                                        {statusType ===
                                                                          "Deleted" && (
                                                                          <>
                                                                            removed
                                                                            (was{" "}
                                                                            {change.field ===
                                                                            "license_img" ? (
                                                                              <img
                                                                                src={
                                                                                  change.oldValue
                                                                                }
                                                                                alt="Old"
                                                                                style={{
                                                                                  width: 80,
                                                                                  height: 50,
                                                                                  objectFit:
                                                                                    "cover",
                                                                                  borderRadius: 4,
                                                                                }}
                                                                              />
                                                                            ) : (
                                                                              change.oldValue
                                                                            )}
                                                                            )
                                                                          </>
                                                                        )}
                                                                      </Typography>

                                                                      {/* <Typography variant="body2">
                                                                        {variantPropName(
                                                                          change.field
                                                                        )}{" "}
                                                                        {statusType ===
                                                                          "Created" && (
                                                                          <>
                                                                            added
                                                                            ➜{" "}
                                                                            {
                                                                              change.newValue
                                                                            }
                                                                          </>
                                                                        )}
                                                                        {statusType ===
                                                                          "Modified" && (
                                                                          <>
                                                                            changed
                                                                            from{" "}
                                                                            <s>
                                                                              {
                                                                                change.oldValue
                                                                              }
                                                                            </s>{" "}
                                                                            ➜{" "}
                                                                            {
                                                                              change.newValue
                                                                            }
                                                                          </>
                                                                        )}
                                                                        {statusType ===
                                                                          "Deleted" && (
                                                                          <>
                                                                            removed
                                                                            (was{" "}
                                                                            {
                                                                              change.oldValue
                                                                            }
                                                                            )
                                                                          </>
                                                                        )}
                                                                      </Typography> */}
                                                                    </Stack>
                                                                  </Box>
                                                                );
                                                              }
                                                            )}
                                                          </>
                                                        )}
                                                    </Box>
                                                  );
                                                })}
                                            </Grid>
                                          ) : (
                                            <Grid item xs={12}>
                                              <Typography
                                                variant="body2"
                                                color="text.secondary"
                                              >
                                                No history available
                                              </Typography>
                                            </Grid>
                                          )}
                                        </Stack>
                                      </CardContent>
                                    </Card>
                                  );
                                })}
                              </Stack>
                            </Box>
                          </Grid>
                        </Card>
                      </Grid>
                    )}
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Dialog open={openImage} onClose={handleCloseImage} maxWidth="xs">
        <Box display="flex" justifyContent="flex-end" alignItems="center" p={1}>
          <Button
            variant="contained"
            className={classes.editButton}
            onClick={handleCloseImage}
          >
            <CloseIcon />
          </Button>
        </Box>

        <DialogContent sx={{ textAlign: "center" }}>
          {selectedEmpImg ? (
            <>
              <img
                src={selectedEmpImg}
                alt="Img"
                style={{
                  width: 400,
                  height: 300,
                  objectFit: "cover",
                  borderRadius: 8,
                }}
              />

              <Box mt={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  component="a"
                  href={selectedEmpImg}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.addButton}
                  startIcon={<DownloadOutlinedIcon />}
                >
                  Download
                </Button>
              </Box>
            </>
          ) : (
            <Typography>No image available</Typography>
          )}
        </DialogContent>
      </Dialog>
      {selectCustomer && (
        <NewPopUpteam
          openModel={openDialog}
          handleCloseDialog={handleCloseDialog}
          data={selectCustomer}
        />
      )}
    </div>
  );
};

export default Index;
